<template>
    <div v-show="((block.linked_to_tab == '' || typeof block.linked_to_tab === 'undefined') || (block.linked_to_tab != '' && current_active_tab.tab_id == block.linked_to_tab && current_active_tab.container_id == container_id))" class='block-container' data-content-type='block' :class="[{'page-builder-mode' : page_builder_mode, 'remove-guides-mode': remove_guides}, classes.block]" :id='block.id' :block-sequence-id='block.sequence_number' :style='[block.compiled_styles, custom_styles.block, drag_padding_styles]'>
        <slot></slot>
    </div>
</template>

<script>
import {deepCopyObject} from "@/global/modules/functions.js";
import format_custom_styles from "@/page_builder/builder/builder_tools/functions/format_custom_styles.js";

export default {
    components: {},
    props:['block', 'page_builder_mode','container_active_tab', 'active_tabs', 'container_id', 'remove_guides'],
    mixins: [format_custom_styles],
    data(){
        return{
            styles:{},
            current_active_tab: '',
            drag_padding_styles: {},
            classes: {}
        }
    },
    methods:{
        setActiveTab(){
            let active_tab = this.active_tabs.filter(x=>x.container_id ==this.container_id)[0];
            if(active_tab != null){
                this.current_active_tab = deepCopyObject(active_tab);
            }
        },
        setClasses(){
            if(this.block.compiled_classes != null){
                this.classes = this.block.compiled_classes;
            }
        },
        setPaddingForDrag(){
            if(this.page_builder_mode){
                let padding = this.block.styles.padding.value;
                let split_padding = padding.split(' ');

                let top = split_padding[0];
                let right = split_padding[1];
                let bottom = split_padding[2];
                let left = split_padding[3];

                this.drag_padding_styles = { //Always set minium padding to allow for dragging
                    'padding-top': `max(16px, ${top})`,
                    'padding-bottom': `max(16px, ${bottom})`,
                    'padding-left': `max(4px, ${left})`,
                    'padding-right': `max(4px, ${right})`,
                };

                if(this.remove_guides){
                    this.drag_padding_styles = { //Always set minium padding to allow for dragging
                    'padding-top': `max(0px, ${top})`,
                    'padding-bottom': `max(0px, ${bottom})`,
                    'padding-left': `max(0px, ${left})`,
                    'padding-right': `max(0px, ${right})`,
                };

                }
            }
        }
    },
    watch:{
        'block': {
            handler(){  
                this.setCustomCssStyles(this.block.custom_styles); //From mixin
                this.setPaddingForDrag();
                this.setClasses();
            },
            deep: true
        },
        'active_tabs': {
            handler(){  
                this.setActiveTab();
            },
            deep: true
        },
        'remove_guides': function(){
            this.setPaddingForDrag();
        }
    },
    mounted(){
        this.setCustomCssStyles(this.block.custom_styles); //From mixin
        this.setActiveTab();
        this.setPaddingForDrag();
        this.setClasses();
    }

}
</script>

<style lang="scss" scoped>
.block-container{
    flex-grow: 1;
    display: flex;
    gap: 10px;
    width: 100%;
    box-sizing: border-box;

    @media(max-width: 768px){ //Hard coded - will need to be dynamic in future
        flex-wrap: wrap;
    }

    @container(width <= 768px) {//Hard coded - will need to be dynamic in future
        flex-wrap: wrap;
    }
}

.block-container.page-builder-mode{
    border: dashed 1px #c92a2a;
    border-radius: 5px;
    // padding: 20px 5px !important;
    position: relative;
    align-items: flex-start; //Allow elements to be different heights in the same block
}

.block-container.remove-guides-mode{
    border: none;
}
</style>